import { Location } from '@angular/common';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from '../../core/components';
import { DailyReportRecipientModel } from '../../models';
import { SettingsService, SiteService } from '../../services';
import { IncidentService } from '../../services/incident.service';
import { modalLarge } from '../../shared/modules/dialogOptions';

@Component({
    selector: 'app-daily-report-recipients',
    templateUrl: './daily-report-recipients.component.html',
    styleUrls: ['./daily-report-recipients.component.scss', '../layout/layout.component.scss']
})
export class DailyReportRecipientsComponent extends BaseComponent implements OnInit {
    emails: any;
    sites: any;
    SiteId: number;
    reportType: any;
    public isAdminOrUserEditor: boolean;
    email: string;
    reportTypes: any;
    type1: string = "Type 1";
    type2: string = "Type 2";
    type3: string = "Type 3";
    modalReference: NgbModalRef;
    showSpinner: boolean;
    deleteId: any;
    openLogs = false
    openLogsLoading = false
    emailLogs = [{CreatedDate:'', Message: '', Recepients: ''}]
    constructor(private siteService: SiteService,
        private incidentService: IncidentService,
        public activeModal: NgbActiveModal,
        public router: Router,
        private toastr: ToastsManager,
        private route: ActivatedRoute,
        private settingService: SettingsService,
        private modalService: NgbModal,
        private vRef: ViewContainerRef,
        private location: Location) {

        super(router);
        this.toastr.setRootViewContainerRef(vRef);
    }

    ngOnInit() {
        //
        let currentUser = super.currentLoggedUser();
        this.accountId = currentUser.accountId
        this.loadSites(this.accountId);

        if (currentUser.role === 'admin') {
            this.isAdminOrUserEditor = true;
            // this.settingList.isAdminOrUserEditor = true;
            //  this.settingList.loadDataById(currentUser.accountId);
        }
        else if (currentUser.role === 'user') {
            this.isAdminOrUserEditor = false;
        }
        else if (currentUser.role === 'superadmin') {
            //this.settingList.isSuperAdmin = true;
            let secondaryUserData = super.secondaryAdminUser();
            if (secondaryUserData) {
                // this.settingList.loadDataById(secondaryUserData.AccountId);
            }
        }
    }

    openLg(content, id) {
        this.deleteId = id;
        this.modalReference = this.modalService.open(content);
    }

    loadReportTypes() {
        this.incidentService.GetAllReportTypes()
            .catch((err: any) => {

                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response) => {
                this.reportTypes = response.Data;
                this.reportType = this.reportTypes[0];
                this.loadSetting();
            });

    }

    loadEmails() {

        let currentUser = super.currentLoggedUser();

        this.incidentService.GetAllEmailsFiltered(currentUser.accountId, this.SiteId, this.reportType == 'DayReport' ? 'DailyReport': this.reportType)
            .catch((err: any) => {

                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response) => {
                this.emails = response.Data;
            });
    };

    deleteEmail(id: number) {
        this.incidentService.DeleteEmail(id)
            .catch((err: any) => {

                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response) => {
                this.email = "";
                this.loadEmails();
                this.modalReference.close();
            });
    }
    public validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    saveEmail() {

        if (!this.validateEmail(this.email)) {
            this.toastr.error("Invalid Email Address", "");
            return;
        }

        var model = new DailyReportRecipientModel();
        let currentUser = super.currentLoggedUser();
        model.AccountId = currentUser.accountId;
        model.Email = this.email;
        model.ReportType = this.reportType;
        model.SiteId = this.SiteId;

        this.incidentService.saveEmail(model)
            .catch((err: any) => {

                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response) => {
                this.email = "";
                this.loadEmails();
            });

    };

    loadSites(accountId: number) {

        this.siteService.getSitesByAccountList(accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.sites = response.Data.filter(x => x.IsActive);
                //  this.SiteId = this.sites[0].Id;

                this.loadReportTypes();

                //  this.toastr.success(response.Message, "Success"); 
            });
    }

    get emailLogReportType() {
        switch (this.reportType) {
            case 'DayReport':
                return 'DailyReport'
            case 'BistroSolna':
                return 'Bistro Solna'
            case 'Handelserapport':
                return 'Handelserapport'
            case 'Ryckrapport':
                return 'IB-Larm och Ryckrapport (internal)'
            case 'Oppettidesrapport':
                return 'Oppettidesrapport'
            case 'SkadegorelserKlotterrapport':
                return 'Skadegorelse/Klotterrapport'
        
            default:
                return this.reportType;
        }
    }

    openEmailLogs() {
        this.openLogsLoading = true
        this.incidentService.getEmailLogs(this.accountId, this.SiteId, this.emailLogReportType).subscribe((res: any[]) => {
            this.openLogsLoading = false
            this.emailLogs = res

            if (this.emailLogs.length > 0) {
                this.openLogs = true
            }
            else {
                this.toastr.warning('No email logs')
            }
        })
    }

    closeEmailLog() {
        this.openLogs = false
        this.emailLogs = []
    }

    loadSetting() {

        var currentUser = JSON.parse(localStorage.getItem('currentUser'));

        this.settingService.getValue("type1", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type1 = response.Data.Value;
                }
            });


        this.settingService.getValue("type2", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type2 = response.Data.Value;
                }
            });

        if (localStorage.getItem('IncidentcurrentSiteId') != null) {
            this.SiteId = +localStorage.getItem('IncidentcurrentSiteId');

            this.loadEmails();
            //alert(this.SiteId);
        }

        this.settingService.getValue("type3", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type3 = response.Data.Value;
                }
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/daily-report-recipients/daily-report-recipients.component.ts